import Model from "./Model";

export default class TextModel extends Model {
  id: number;
  body: string;
  alignment: string;
  source: any;
  static __typename: string = "Text";

  constructor(text: any, getters: any) {
    super(getters);
    this.id = text.id;
    this.body = text.body;
    this.alignment = text.alignment;
    this.source = text.source;
  }
  raw() {
    return {
      id: this.id,
      body: this.body,
      alignment: this.alignment,
      source: this.source,
      __typename: TextModel.__typename
    };
  }
}